import type {ThemeBreakpoints} from '_uiComponents'

const homePage = {
    HomePage: {
        baseStyle: ({headerSize, accessibilityBannerSize}: {headerSize: ThemeBreakpoints; accessibilityBannerSize: ThemeBreakpoints}) => ({
            container: {
                gap: 0,
                w: '100%',
                pt: {
                    base: `${headerSize.base}px`,
                    sm: `${headerSize.sm}px`,
                    md: `${headerSize.md}px`,
                    lg: `${headerSize.lg}px`,
                    xl: `${accessibilityBannerSize.xl || 0}px`,
                    '2xl': `${accessibilityBannerSize['2xl'] || 0}px`,
                },
            },
        }),
    },
}

export default homePage
